export const TrashOutlinedIcon = ({ className }: { className?: string }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M15.833 5.83333L15.1102 15.9521C15.0479 16.8243 14.3222 17.5 13.4478 17.5H6.55153C5.67714 17.5 4.9514 16.8243 4.88911 15.9521L4.16634 5.83333M8.333 9.16667V14.1667M11.6663 9.16667V14.1667M12.4997 5.83333V3.33333C12.4997 2.8731 12.1266 2.5 11.6663 2.5H8.333C7.87276 2.5 7.49967 2.8731 7.49967 3.33333V5.83333M3.33301 5.83333H16.6663"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
